module.exports = __webpack_public_path__ + "static/media/Soft_Pastel.2e1510f9.png";